import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import PlanTrip from "../components/PlanTrip";
import AboutMain from "../images/about/about-main.jpg";
import Box1 from "../images/about/icon1.png";
import Box2 from "../images/about/icon2.png";
import Box3 from "../images/about/icon3.png";
import { Helmet } from "react-helmet";

function About() {
  return (
    <>
      <Helmet>
        <title>About Us - Bulls Eye Car Rental</title>

        <meta
          name="description"
          content="Established in 2014, Bulls Eye Car Rental is located at Tract # 2 Britannia Blvd & Sunset Highway, Freeport, Grand Bahama. Offering reliable and convenient car rental services, they are committed to ensuring a seamless travel experience for their customers."
        />
        {/* Add more meta tags as needed */}
      </Helmet>

      <section className="about-page">
        <HeroPages name="About" />
        <div className="container">
          <div className="about-main">
            <img
              className="about-main__img"
              src={'https://images.pexels.com/photos/7144174/pexels-photo-7144174.jpeg?auto=compress&cs=tinysrgb&w=600'}
              alt="car-rental dealership"
            />
            <div className="about-main__text">
              {/*
              <h3 style={{marginBottom:'30px', fontSize:'32px', textAlign:'center'}}>About Company</h3>
              <h3>Mission Statement
              </h3>

              <h4 style={{marginBottom:'15px', fontStyle:'italic'}} > "Where every journey is a unique story, and every traveler is a valued companion."
              </h4 >

              <h3>Vision Statement
              </h3>

              <h4 style={{fontStyle:'italic'}}>“To revolutionize the travel experience through cutting-edge technology, while envisioning a future where every journey is a personalized, immersive, and unforgettable adventure.”
              </h4>
 */}

              <p>
              Welcome to Bulls Eye Car Rental, your trusted partner for hassle-free transportation in the heart of Freeport, Grand Bahama. Established in 2014, we are conveniently located at Tract # 2 Britannia Blvd & Sunset Highway, we offer a diverse fleet of vehicles, including cars and scooters, to suit all your travel needs. Whether you're exploring the stunning beaches, heading to a business meeting, or simply cruising around town, we ensure your journey is smooth, reliable, and comfortable. At Bulls Eye Car Rental, we pride ourselves on exceptional customer service, affordable rates, and a commitment to making your travel experience unforgettable. Choose us for your next adventure in Grand Bahama!
              </p>
             
            </div>
          </div>

          {/*   <PlanTrip /> */}
         
        </div>
      </section>
      <div className="book-banner">
        <div className="book-banner__overlay"></div>
        <div className="container">
          <div className="text-content">
            <h2>Book a car by getting in touch with us</h2>
            <span>
              <i className="fa-solid fa-phone"></i>
              <h3 style={{color:'gold'}}>+1 242-373-2277</h3> 
            </span>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default About;
